import { StatusService } from './../../status.service';
import { LocalStorageService } from './../../local-storage.service';
import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
//import { IonSlides } from '@ionic/angular';
import { Router } from '@angular/router';
//import Virtual from 'swiper';
import type Swiper from 'swiper';

@Component({
  selector: 'app-intro-index',
  templateUrl: './intro-index.component.html',
  styleUrls: ['./intro-index.component.scss'],
})
export class IntroIndexComponent implements AfterViewInit {
  headlines = ['WILLKOMMEN', 'ORIENTIERUNG', 'PRIVATSPHÄRE', 'TIPPS 1/4','TIPPS 2/4','TIPPS 3/4','TIPPS 4/4', 'START'];
  currentHeadline= '';
  currentMarginClass= '';
  @ViewChild('swiperContainer', { read: ElementRef  })
  private swiperContainerRef?: ElementRef<HTMLElement>;
  private slider?: Swiper;

constructor(
  private statusService: StatusService,
  private localStorageService: LocalStorageService,
  private router: Router) { }

  ngAfterViewInit(): void {
    this.refreshSwiperRef();

    if(this.statusService.hasTestFinished()){
      this.router.navigate(['/questionnaire/continue']);
    }
    else if(this.statusService.hasIntroFinished()){
      this.router.navigate(['/questionnaire/question']);
    }
    this.currentHeadline = this.headlines[0];
    this.currentMarginClass = 'ml-0';
  }

  // Wird vom Template via (swiperinit) aufgerufen
  onSwiperInit(event: Event): void {
    const el = event.target as any;
    this.slider = el?.swiper as Swiper | undefined;
  }

  onSlideChange(): void {
    const slider = this.getActiveSlider();
    if (!slider) {
      return;
    }
    this.currentHeadline = this.headlines[slider.realIndex];
    this.currentMarginClass = 'ml-'+slider.realIndex+'0';
  }



  public next = (): void => {
    const slider = this.getActiveSlider();
    if (!slider) {
      return;
    }

    if (!slider.isEnd) {
      slider.slideNext();
      return;
    }
    else{
      this.localStorageService.set('hasIntroFinished', true);
      //redirect to start page afterwards
      this.router.navigate(['/questionnaire/question']);
    }
  };

  public last = (): void => {

      this.getActiveSlider()?.slidePrev();
    };
  private refreshSwiperRef(): void {
    const el = this.swiperContainerRef?.nativeElement as any;
    const swiper = el?.swiper as Swiper | undefined;

    // Nur übernehmen, wenn vorhanden und nicht destroyed
    if (swiper && !swiper.destroyed) {
      this.slider = swiper;
    }
  }

  private getActiveSlider(): Swiper | undefined {
    // Falls alte Referenz destroyed ist, neu holen
    if (!this.slider || (this.slider as any).destroyed) {
      this.refreshSwiperRef();
    }
    return this.slider && !(this.slider as any).destroyed ? this.slider : undefined;
  }
}
